import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Grid,
  Menu,
  Modal,
  Icon,
  Form,
  Dropdown,
} from "semantic-ui-react";
import ChatTable from "../react-lib/apps/IsHealth/Chat/ChatTable";
import AppointmentChatTable from "./AppointmentChatTable";
import { Route } from "react-router-dom";
import { useHistory } from "react-router-dom";
import TimeNurse from "../react-lib/apps/QUE/TimeNurse";
import TimeDoctor from "../react-lib/apps/QUE/TimeDoctor";
import TimeDoctorEdit from "../react-lib/apps/QUE/TimeDoctorEdit";
import DoctorScheduleView from "../react-lib/apps/QUE/DoctorScheduleView";
import ModSelectAppointment from "../react-lib/apps/IsHealth/Common/ModSelectAppointment";
import Dashboard from "../react-lib/apps/IsHealth/Dashboard/Dashboard";
import FormAnalytics from "./FormAnalytics";
import QAChatTable from "../react-lib/apps/IsHealth/Platform/QAChatTable";
import config from "../config/config";
import { vcMessenger } from "../react-lib/compat/vc-websocket";

import AppointmentDashboard from "../react-lib/apps/IsHealth/APP/AppointmentDashboard";

const PAGE = {
  CHAT: "/Chat",
  SCHEDULE: "/Schedule",
  MY_SCHEDULE: "/MySchedule",
  DASHBOARD: "/Dashboard",
  APPOINTMENT_CHAT: "/Appointment",
  APPOINTMENT_DASHBOARD: "/AppointmentDashboard",
  DOCTOR_SCHEDULE: "/DoctorSchedule",
  MESSAGES: "/messages",
  RESOLVE_CHAT: "/resolve-chat",
  FORM_ANALYTICS: "/FormAnalytics",
  CLASSIFY_CHAT: "/ClassifyChat",
  AIRFLOW_CHAT: "/IsolationChat",
};

const MainScreen = React.forwardRef((props, ref) => {
  const [currentPage, setCurrentPage] = React.useState("");
  const [openModChooseAppointment, setOpenModChooseAppointment] =
    React.useState(false);
  const [patientAppointmentId, setPatientAppointmentId] = React.useState(null);

  const chatTable = React.useRef();
  const appointmentTable = React.useRef();
  const dashboardRef = React.useRef();
  const qaChatTable = React.useRef();
  const history = useHistory();

  React.useImperativeHandle(ref, () => ({
    chatTable: chatTable.current,
    appointmentTable: appointmentTable.current,
    dashboard: dashboardRef.current,
    qaChatTable: qaChatTable.current,
  }));

  React.useEffect(() => {
    console.log(props);
    if (history.location.pathname.includes(PAGE.CHAT)) {
      setCurrentPage(PAGE.CHAT);
    } else if (history.location.pathname.includes(PAGE.SCHEDULE)) {
      setCurrentPage(PAGE.SCHEDULE);
    } else if (history.location.pathname.includes(PAGE.MY_SCHEDULE)) {
      setCurrentPage(PAGE.MY_SCHEDULE);
    } else if (history.location.pathname.includes(PAGE.DASHBOARD)) {
      setCurrentPage(PAGE.DASHBOARD);
    } else if (history.location.pathname.includes(PAGE.APPOINTMENT_DASHBOARD)) {
      setCurrentPage(PAGE.APPOINTMENT_DASHBOARD);
    } else if (history.location.pathname.includes(PAGE.DOCTOR_SCHEDULE)) {
      setCurrentPage(PAGE.SCHEDULE);
    } else if (history.location.pathname.includes(PAGE.MESSAGES)) {
      setCurrentPage(PAGE.MESSAGES);
    } else if (history.location.pathname.includes(PAGE.APPOINTMENT_CHAT)) {
      setCurrentPage(PAGE.APPOINTMENT_CHAT);
    } else if (history.location.pathname.includes(PAGE.FORM_ANALYTICS)) {
      setCurrentPage(PAGE.FORM_ANALYTICS);
    } else if (history.location.pathname.includes(PAGE.CLASSIFY_CHAT)) {
      setCurrentPage(PAGE.CLASSIFY_CHAT);
    } else if (history.location.pathname.includes(PAGE.AIRFLOW_CHAT)) {
      setCurrentPage(PAGE.AIRFLOW_CHAT);
    } else {
      history.push("/Chat");
    }
  }, [history.location]);

  React.useEffect(() => {
    if (currentPage !== PAGE.DASHBOARD) {
      props.onReconnectWs();
    }
  }, [currentPage]);

  React.useEffect(() => {
    props.onGetDivision();
  }, []);

  const handleCreateAppointment = ({ contentPayload, appointmentId } = {}) => {
    let id = contentPayload
      ? contentPayload.patient_appointment
      : appointmentId;
    setPatientAppointmentId(id);
    setOpenModChooseAppointment(true);
  };

  const handleNavigationMessage = ({
    content = "",
    contentPayload = null,
  } = {}) => {
    if (content.includes("{ตารางออกตรวจผู้ให้คำปรึกษา}")) {
      let contentArr = content.split("{ตารางออกตรวจผู้ให้คำปรึกษา}");
      return (
        <div>
          {contentArr.map((item, index) => {
            if (index !== contentArr.length - 1) {
              return (
                <>
                  {item}
                  <span
                    className="textButton"
                    onClick={() => handleCreateAppointment({ contentPayload })}
                  >
                    ตารางออกตรวจผู้ให้คำปรึกษา
                  </span>
                </>
              );
            }
          })}
        </div>
      );
    } else {
      return content;
    }
  };

  return (
    <div className="MainScreen">
      <ModSelectAppointment
        controller={props.queueController}
        open={openModChooseAppointment}
        onClose={() => {
          setPatientAppointmentId(null);
          setOpenModChooseAppointment(false);
        }}
        patientAppointmentId={patientAppointmentId}
        division={props.division}
      />
      <Menu secondary>
        {props.getLeftMenuItem()}
        {props.getDivisionMenuItem()}
        {props.getRightMenuItem()}
      </Menu>
      <Grid>
        {!config.HIDE_SIDEBAR && (
          <Grid.Column className="tab">
            {config.DASHBOARD && (
              <Button
                className="tabButton"
                icon="pie chart"
                active={currentPage === PAGE.DASHBOARD}
                onClick={() => history.push("/Dashboard/")}
              />
            )}
            <Button
              className="tabButton"
              icon="chat"
              active={currentPage === PAGE.CHAT}
              onClick={() => history.push("/Chat/")}
            />
            {config.CLASSIFY_CHAT && (
              <Button
                className="tabButton"
                icon="comment alternate outline"
                active={currentPage === PAGE.CLASSIFY_CHAT}
                onClick={() => history.push("/ClassifyChat/")}
              />
            )}
            {config.AIRFLOW_CHAT && (
              <Button
                className="tabButton"
                icon="comment alternate"
                active={currentPage === PAGE.AIRFLOW_CHAT}
                onClick={() => history.push("/IsolationChat/")}
              />
            )}
            {config.APPOINTMENT_CHAT_FUNCTION && (
              <Button
                className="tabButton"
                icon="calendar check"
                active={currentPage === PAGE.APPOINTMENT_CHAT}
                onClick={() => history.push("/Appointment/")}
              />
            )}
            {config.BOOKING_FUNCTION && (
              <Button
                className="tabButton"
                icon="calendar"
                active={currentPage === PAGE.MY_SCHEDULE}
                onClick={() => history.push("/MySchedule/")}
              />
            )}
            {config.BOOKING_FUNCTION && (
              <Button
                className="tabButton"
                icon="users"
                active={currentPage === PAGE.SCHEDULE}
                onClick={() => history.push("/Schedule/")}
              />
            )}
            {config.DASHBOARD && (
              <Button
                className="tabButton"
                icon="users"
                active={currentPage === PAGE.APPOINTMENT_DASHBOARD}
                onClick={() => history.push("/AppointmentDashboard/")}
              />
            )}
            {config.FORM_ANALYTICS && (
              <Button
                className="tabButton"
                icon="wpforms"
                active={currentPage === PAGE.FORM_ANALYTICS}
                onClick={() => history.push("/FormAnalytics/")}
              />
            )}
          </Grid.Column>
        )}
        <Grid.Column
          className={`page ${config.HIDE_SIDEBAR ? "hide-sidebar" : ""}`}
        >
          <Route
            exact
            path="/Chat/:encounterId?/:chatChannelId?/"
            render={(chatProps) => (
              <ChatTable
                {...props}
                {...chatProps}
                ref={chatTable}
                // ref={ref => (this.chatTable = ref)}
                allowCreateAppoint={config.BOOKING_FUNCTION ? true : false}
                controller={props.chatController}
                diagFormController={props.diagFormController}
                patientPanelController={props.patientPanelController}
                nurseNoteController={props.nurseNoteController}
                progressNoteController={props.progressNoteController}
                classifyController={props.classifyController}
                apiToken={props.apiToken}
                onGetDivision={props.loadMydivision}
                division={props.division}
                userId={props.userId}
                fullname={props.fullname}
                username={props.username}
                finishedTriageLevel={props.finishedTriageLevel}
                onNavigationMessage={handleNavigationMessage}
                onEditAppointment={handleCreateAppointment}
                isPatient={false}
              />
            )}
          />
          {config.CLASSIFY_CHAT && (
            <Route
              exact
              path="/ClassifyChat/:triageLevel?/:diagFormId?"
              render={(chatProps) => (
                <QAChatTable
                  apiToken={props.apiToken}
                  division={props.division}
                  finishedTriageLevel={props.finishedTriageLevel}
                  {...props}
                  {...chatProps}
                  ref={qaChatTable}
                  // ref={ref => (this.chatTable = ref)}
                  allowCreateAppoint={config.BOOKING_FUNCTION ? true : false}
                  // Controller
                  controller={props.chatController}
                  diagFormController={props.diagFormController}
                  patientPanelController={props.patientPanelController}
                  nurseNoteController={props.nurseNoteController}
                  progressNoteController={props.progressNoteController}
                  classifyController={props.classifyController}
                  crdVitalSignController={props.crdVitalSignController}
                  onGetDivision={props.onGetDivision}
                  dashboardController={props.dashboardController}
                  queueController={props.queueController}
                  // Data
                  userId={props.userId}
                  fullname={props.fullname}
                  username={props.username}
                  finishedTriageLevel={props.finishedTriageLevel}
                  storage={props.storage}
                  isPatient={false}
                  // Callback
                  onNavigationMessage={handleNavigationMessage}
                  onEditAppointment={handleCreateAppointment}

                  // onSetShowMenuNoti={(show) =>
                  //   props?.onSetState({ showMenuNoti: show })
                  // }
                />
              )}
            />
          )}
          {config.AIRFLOW_CHAT && (
            <Route
              exact
              path="/IsolationChat/:triageLevel?/:diagFormId?"
              render={(chatProps) => (
                <QAChatTable
                  apiToken={props.apiToken}
                  division={props.division}
                  finishedTriageLevel={props.finishedTriageLevel}
                  {...props}
                  {...chatProps}
                  ref={qaChatTable}
                  // ref={ref => (this.chatTable = ref)}
                  allowCreateAppoint={config.BOOKING_FUNCTION ? true : false}
                  // Controller
                  controller={props.chatController}
                  diagFormController={props.diagFormController}
                  patientPanelController={props.patientPanelController}
                  nurseNoteController={props.nurseNoteController}
                  progressNoteController={props.progressNoteController}
                  classifyController={props.classifyController}
                  crdVitalSignController={props.crdVitalSignController}
                  onGetDivision={props.onGetDivision}
                  dashboardController={props.dashboardController}
                  queueController={props.queueController}
                  // Data
                  userId={props.userId}
                  fullname={props.fullname}
                  username={props.username}
                  finishedTriageLevel={props.finishedTriageLevel}
                  storage={props.storage}
                  isPatient={false}
                  // Callback
                  onNavigationMessage={handleNavigationMessage}
                  onEditAppointment={handleCreateAppointment}
                  // onSetShowMenuNoti={(show) =>
                  //   props?.onSetState({ showMenuNoti: show })
                  // }
                  // config
                  AIRFLOW_CHAT={true}
                />
              )}
            />
          )}
          {config.APPOINTMENT_CHAT_FUNCTION && (
            <Route
              exact
              path="/Appointment/:patientId?/:chatChannelId?/"
              render={(chatProps) => (
                <AppointmentChatTable
                  {...props}
                  {...chatProps}
                  ref={appointmentTable}
                  // ref={ref => (this.chatTable = ref)}
                  allowCreateAppoint={true}
                  controller={props.appointmentChatController}
                  diagFormController={props.diagFormController}
                  patientPanelController={props.patientPanelController}
                  nurseNoteController={props.nurseNoteController}
                  progressNoteController={props.progressNoteController}
                  classifyController={props.classifyController}
                  apiToken={props.apiToken}
                  onGetDivision={props.loadMydivision}
                  division={props.division}
                  userId={props.userId}
                  fullname={props.fullname}
                  username={props.username}
                  finishedTriageLevel={props.finishedTriageLevel}
                  onNavigationMessage={handleNavigationMessage}
                  onEditAppointment={handleCreateAppointment}
                  isPatient={false}
                />
              )}
            />
          )}
          {config.BOOKING_FUNCTION && (
            <Route
              exact
              path="/Schedule/"
              render={(appProps) => (
                <TimeNurse
                  {...props}
                  {...appProps}
                  queueController={props.queueController}
                />
              )}
            />
          )}
          {config.DASHBOARD && (
            <Route
              exact
              path="/AppointmentDashboard/"
              render={(appProps) => (
                <AppointmentDashboard
                  {...props}
                  {...appProps}
                  controller={props.appointmentDashboardController}
                />
              )}
            />
          )}
          {config.BOOKING_FUNCTION && (
            <Route
              exact
              path="/DoctorSchedule/:providerId/:date?/"
              render={(appProps) => {
                return (
                  <DoctorScheduleView
                    {...props}
                    {...appProps}
                    controller={props.queueController}
                  />
                );
              }}
            />
          )}
          {config.BOOKING_FUNCTION && (
            <Route
              exact
              path="/MySchedule/"
              render={(appProps) => (
                <TimeDoctor
                  {...appProps}
                  controller={props.queueController}
                  apiToken={props.apiToken}
                  providerId={props.providerId}
                  onClickDaySlot={({ index, weekStartSerial }) => {
                    history.push(
                      "/MySchedule/" + index + "/" + weekStartSerial + "/"
                    );
                  }}
                />
              )}
            />
          )}
          {config.BOOKING_FUNCTION && (
            <Route
              exact
              path="/MySchedule/:id/:weekStartSerial?/"
              render={(appProps) => (
                <TimeDoctorEdit
                  {...appProps}
                  controller={props.queueController}
                  apiToken={props.apiToken}
                  providerId={props.providerId}
                />
              )}
            />
          )}
          {config.DASHBOARD && (
            <Route
              exact
              path="/Dashboard/"
              render={(appProps) => (
                <Dashboard
                  {...appProps}
                  ref={dashboardRef}
                  apiToken={props.apiToken}
                  division={props.division}
                  controller={props.dashboardController}
                />
              )}
            />
          )}
          {config.FORM_ANALYTICS && (
            <Route
              exact
              path="/FormAnalytics/"
              render={(appProps) => (
                <FormAnalytics
                  {...appProps}
                  ref={dashboardRef}
                  apiToken={props.apiToken}
                  division={props.division}
                  controller={props.dashboardController}
                  onEvent={props.onEvent}
                  patientSegmentList={props.patientSegmentList}
                  diagFormDetail={props.diagFormDetail}
                  chatController={props.chatController}
                  isLoadingFormAnalytics={props.isLoadingFormAnalytics}
                  diagFormController={props.diagFormController}
                  divisionProfileList={props.divisionProfileList}
                  divisionHasUser={props.myDivisions}
                />
              )}
            />
          )}
        </Grid.Column>
      </Grid>
    </div>
  );
});

MainScreen.defaultProps = {
  diagFormController: {},
  chatController: {},
  appointmentChatController: {},
  patientPanelController: {},
  nurseNoteController: {},
  progressNoteController: {},
  classifyController: {},
  onGetDivision: () => {},
  finishedTriageLevel: [],
  queueController: {},
  myDivisions: [],
  storage: {},
};

MainScreen.propTypes = {
  diagFormController: PropTypes.object,
  chatController: PropTypes.object,
  appointmentChatController: PropTypes.object,
  patientPanelController: PropTypes.object,
  nurseNoteController: PropTypes.object,
  progressNoteController: PropTypes.object,
  classifyController: PropTypes.object,
  apiToken: PropTypes.string,
  onGetDivision: PropTypes.func,
  division: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  fullname: PropTypes.string,
  username: PropTypes.string,
  finishedTriageLevel: PropTypes.array,
  queueController: PropTypes.object,
  myDivisions: PropTypes.array,
  storage: PropTypes.object,
};

export default React.memo(MainScreen);
